import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'
import { CreateInterviewTemplateForm } from './common/CreateInterviewTemplateForm/CreateInterviewTemplateForm'

import { useCreateInterviewTemplateModalState } from './hooks'

import styles from './CreateInterviewTemplateModal.module.scss'

export const CreateInterviewTemplateModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useCreateInterviewTemplateModalState({
    onCancel,
    onClose,
    onConfirm,
  })

  const {
    form: { competencies, control, formState, watch },
    language,
    isConfirmationOpen,
  } = state
  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
  } = handlers

  return (
    <>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Next`}
        title={t`Create interview template`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <CreateInterviewTemplateForm
            {...{ competencies, control, formState, language, watch }}
          />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
